import {
  SubscriptionDetails,
  PendingSubscriptionFull
} from "../../../../../../types"
import Accordion from "../../../../accordion"
import SectionCell from "../../../../section/cell"
import LoFields from "./accordion-sections/lo-fields"
import LoanScenario from "./accordion-sections/loan-scenario"
import Misc from "./accordion-sections/misc"
import PropertyLocation from "./accordion-sections/property-location"
import {
  formatPhoneNumber,
  formatDateTimeFromMillis
} from "../../../../../utils"
import { getPendingSubscriptionStatus } from "../../../../../utils/dream-rate"

interface Props {
  data: SubscriptionDetails | PendingSubscriptionFull
  loEmail?: string
}

const EngagementSummary = ({ data, loEmail }: Props) => (
  <div className="max-w-3xl">
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <SectionCell
        label="First name"
        value={data.first_name}
        className="!pt-0"
      />
      <SectionCell label="Last name" value={data.last_name} className="!pt-0" />
      <SectionCell
        label="Email address"
        value={data.email}
        className="!pt-0"
        truncateValue
      />
      <SectionCell
        label="Phone number"
        value={formatPhoneNumber(data.phone)}
        className="!pt-0"
      />
      {/* Dream Rate specific fields */}
      {"trigger_rate" in data && (
        <>
          <SectionCell
            label="Dream rate"
            value={`${(data.trigger_rate ?? 0).toFixed(2)}%`}
            className="!pt-0"
          />
          <SectionCell
            label="Status"
            value={getPendingSubscriptionStatus(data as PendingSubscriptionFull)
              .replace("delete", "Deleted")
              .replace("active", "Active")
              .replace("pending", "Pending")
              .replace("cancelled", "Cancelled")}
            className="!pt-0"
          />
        </>
      )}

      <SectionCell
        label="Created by"
        value={
          loEmail
            ? loEmail
            : ("lead" in data ? data?.lead?.owner : undefined) ?? "-"
        }
        className="!pt-0"
        truncateValue
      />
      <SectionCell
        label="Created on"
        value={formatDateTimeFromMillis(
          parseInt((data.created ?? 0).toString()) * 1000
        )}
        className="!pt-0"
      />
    </div>

    <div className="grid gap-4 mt-6">
      <div>
        <Accordion title="Property location" openByDefault>
          <PropertyLocation data={data as SubscriptionDetails} />
        </Accordion>
      </div>
      <div>
        <Accordion title="Loan scenario" openByDefault>
          <LoanScenario quote_info={data.quote_info as any} />
        </Accordion>
      </div>
      <div>
        <Accordion title="Loan officer fields" openByDefault>
          <LoFields data={data as SubscriptionDetails} />
        </Accordion>
      </div>
      <div>
        <Accordion title="Misc." openByDefault>
          <Misc data={data as SubscriptionDetails} />
        </Accordion>
      </div>
    </div>
  </div>
)

export default EngagementSummary
